// extracted by mini-css-extract-plugin
export var button = "_kq-2";
export var card = "_kq-0";
export var closeButtonContainer = "_kq-3";
export var iconContainer = "_kq-1";